<script setup>
import { defineEmits, ref } from 'vue'
import { getDefaultLocale } from '@/pages/global/utils/locale'
import lang from '@/pages/global/verifyMetaData/lang.json'
import getUA from '@utils/getUA'

const defaultLocal = getDefaultLocale()
const local = ref(defaultLocal)
const languages = new Proxy(lang, {
  get: function (target, property) {
    if (target[property]) {
      return target[property][local.value] || target[property].en
    }
    return ''
  }
})

const emits = defineEmits(['track'])
const handleToApp = () => {
  const storeUrl = getUA().isIOS
    ? 'https://apps.apple.com/us/app/timemark-timestamp-camera-gps/id6446071834'
    : 'https://play.google.com/store/apps/details?id=com.oceangalaxy.camera.new'
  emits('track', 'getApp', { url: storeUrl })
  window.open(storeUrl, '_blank')
}
</script>

<template>
  <div class="navbar-wrapper">
    <div class="navbarLeft">
      <div class="timemarkLogo">
        <img
          src="@/pages/global/verifyMetaData/assets/TimemarkLogo.png"
          alt=""
        />
      </div>
      <div>Timemark</div>
    </div>
    <div class="navbarRight">
      <div class="btn" @click="handleToApp">{{ languages.i_h5_get_app }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.navbar-wrapper {
  box-sizing: border-box;
  width: 100vw;
  height: 60px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;

  .navbarLeft {
    font-weight: 590;
    font-size: 18px;
    display: flex;
    align-items: center;
    gap: 6px;

    .timemarkLogo {
      width: 30px;
      height: 30px;
    }
  }

  .navbarRight {
    .btn {
      padding: 0 8px;
      font-weight: 590;
      font-size: 14px;
      height: 25px;
      background: rgba(61, 110, 153, 1);
      border-radius: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: rgba(255, 255, 255, 0.8);
    }
  }
}
</style>
